import cx from 'classnames';
import i18n from '../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import Checkbox from '@adsk/bim360-matrix-react-checkbox';
import InfoPopover from '@adsk/bim360-matrix-react-info-popover';
import PropTypes from 'prop-types';
import React from 'react';

const IssueNewModalFooter = ({
  isSubmitting,
  allowCreateAnother,
  isCreateAnotherChecked,
  setIsCreateAnotherChecked,
  save,
  onClose,
  container
}) => {
  const saveButtonClasses = cx('IssueNew__create-button', {
    ['IssueNew__create-button--saving']: isSubmitting
  });
  const saveButtonText = isSubmitting ? i18n.t('new.creating') : i18n.t('new.create');
  return (
    <div className="IssueNew__button-footer">
      <div className="IssueNew__button-footer-create-another" data-testid="IssueNew__createAnother">
        {allowCreateAnother && (
          <React.Fragment>
            <Checkbox
              onChange={() => setIsCreateAnotherChecked(!isCreateAnotherChecked)}
              checked={isCreateAnotherChecked}
              label={i18n.t('new.createAnother')}
            />
            <InfoPopover
              container={container}
              message={i18n.t('new.createAnotherTooltip')}
              tooltipClassName="IssueNew__button-footer-create-another-tooltip"
            />
          </React.Fragment>
        )}
      </div>
      <Button styleType={Button.StyleType.LINK_SECONDARY} onClick={onClose} data-testid="IssueNew__cancelButton">
        {i18n.t('navigation.cancel')}
      </Button>
      <Button
        styleType={Button.StyleType.PRIMARY}
        className={saveButtonClasses}
        data-testid="IssueNew__createButton"
        onClick={save}
        disabled={isSubmitting}
      >
        {saveButtonText}
      </Button>
    </div>
  );
};

IssueNewModalFooter.displayName = 'IssueNewModalFooter';

IssueNewModalFooter.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  allowCreateAnother: PropTypes.bool.isRequired,
  isCreateAnotherChecked: PropTypes.bool.isRequired,
  setIsCreateAnotherChecked: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  container: PropTypes.object
};

export default IssueNewModalFooter;
